import { z } from 'zod/v4';

// Lengths follow the `allowed_origins` columns. Legacy allowed `name` up to 511
// and `companyId` up to 255 against `varchar(255)` / `varchar(36)` columns, so
// a longer value passed validation and failed in the insert as a 500.
export const AdminCreateAllowedOriginBodySchema = z.object({
  origin: z.string().min(1).max(511),
  name: z.string().max(255).nullish(),
  prettyOrigin: z.string().max(511).nullish(),
  companyId: z.string().max(36).nullish(),
});

export type AdminCreateAllowedOriginBody = z.infer<
  typeof AdminCreateAllowedOriginBodySchema
>;

// The allowed-origin row, inside the platform's `{ data, metadata }` envelope
// (legacy sent it bare). Legacy answered every column; this keeps the ones the
// admin screens read plus the unscoped audit columns, and leaves out the
// impersonate / api-key ones no consumer reads.
export const AdminAllowedOriginSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  origin: z.string(),
  prettyOrigin: z.string().nullable(),
  companyId: z.string().nullable(),
  /** Joined from `companies_view`; null when no (existing) company is attached. */
  companyName: z.string().nullable(),
  createdAt: z.coerce.date().nullable(),
  createdByUserId: z.string().nullable(),
  createdByCompanyId: z.string().nullable(),
  updatedAt: z.coerce.date().nullable(),
  updatedByUserId: z.string().nullable(),
  updatedByUserName: z.string().nullable(),
  updatedByCompanyId: z.string().nullable(),
  updatedByCompanyName: z.string().nullable(),
});

export type AdminAllowedOrigin = z.infer<typeof AdminAllowedOriginSchema>;
